import React from 'react';
import MenuItem from '@mui/material/MenuItem';
import styled from 'styled-components';

const StyledMenuItem = styled(MenuItem)`
&& {
  border: 0;
  color: #758081;
  padding: 0;
  overflow: hidden;
  
  /* Hide direct child span when there's an anchor tag */
  a ~ span:not(.MuiTouchRipple-root),
  & > span:empty:not(.MuiTouchRipple-root) {
    display: none !important;
    pointer-events: none !important;
    visibility: hidden !important;
    position: absolute !important;
    width: 0 !important;
    height: 0 !important;
    opacity: 0 !important;
    z-index: -1 !important;
  }
  
  /* Ensure anchor tag takes full width and is clickable */
  & > a {
    position: relative;
    z-index: 1;
  }
  
    svg {
        flex-shrink: 0;
        width: 1em;
        height: 1em;
        font-size: 1.2857142857142856rem;
        
    }
  
  a, > span {
    color: inherit;
    text-decoration: none;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    padding: 12px 16px;
    width: 100%;
    gap: 19px;
    box-sizing: border-box;
    
    .menu-label {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      font-size: 13px;
    }
    
    &.active {
        color: rgb(19, 118, 157);
        position: relative;
        &::before {
            content: '';
            display: block;
            position: absolute;
            background: #53C4CC;
            left: 0;
            top: 50%;
            transform: translateY(-50%);
            height: 50%;
        }
    }
  }
   
  &:hover {
    a, > span:not(.MuiTouchRipple-root) {
        color: white !important;
        background: rgb(19, 118, 157);
        width: 100% !important;
        position: relative;
        
        * {
          color: white !important;
        }
    }
    svg {
      color: white !important;
    }
    .menu-label {
      color: white !important;
    }
  }
  
  a.active, > span.active {
    color: rgb(19, 118, 157);
  }
`;

const CustomMenuItem = React.forwardRef((props, ref) => {
  return (
    <StyledMenuItem {...props} ref={ref} component="li">
      {props.children}
    </StyledMenuItem>
  );
})


export default CustomMenuItem;